module.exports = __webpack_public_path__ + "static/media/09_Janas_webfinal.13862fde.jpg";